import TableFilter from '@/components/common/tablefilter/TableFilter.vue'
import { mapState } from 'vuex';

export default {
  name: 'BillReport',
  data () {
    return {
      isMounted: false,
      filterValues: {
        fromDatePeriod: null,
        toDatePeriod: null,
        dateFrom: '',
        dateTo: '',
        materialGroups: [],
        advanceBills: [],
        isPaid: [],
        axPvnGroups: [],
        simple: true
      },
      reportData: [],
      reportColumns: [],
      downloading: false,
      loading: false,
      currentReq: null,
      simpleView: true,
      tableHeaders: [],
      paging: { limit: 50, total: 0, page: 1, pages: 1 }
    }
  },
  components: {
    TableFilter
  },
  computed: {
    ...mapState(['config']),
    advanceFilterOptions () {
      return [
        { code: 0, text: this.$t('report-summaries.bill.noRealBill') },
        { code: 1, text: this.$t('report-summaries.bill.hasRealBill') }
      ]
    },
    axPvnGroupOptions () {
      return this.$store.getters.getConfigOptions('ax_pvn_groups', this.$i18n.locale);
    },
    filters () {
      const filters = {};
      filters.fromDatePeriod = { type: 'date-period', label: this.$t('report-summaries.bill.date-period-from'), class: 'col-md-2' };
      filters.toDatePeriod = { type: 'date-period', label: this.$t('report-summaries.bill.date-period-to'), class: 'col-md-2' };
      filters.dateFrom = { type: 'date', label: this.$t('report-summaries.bill.dateFrom'), class: 'col-md-2' };
      filters.dateTo = { type: 'date', label: this.$t('report-summaries.bill.dateTo'), class: 'col-md-2' };
      filters.isPaid = { type: 'checkbox', label: this.$t('report-summaries.bill.remainingBalance'), colOnlyFilter: true, options: this.yesNoOptions, class: 'col-md-2' }
      filters.billNumber = { type: 'text', label: this.$t('bill.number'), class: 'col-md-2' };
      filters.axPvnGroups = { type: 'checkbox', label: this.$t('report-summaries.bill.axPvnGroups'), options: this.axPvnGroupOptions, textField: 'code' }
      filters.materialGroups = { type: 'checkbox', label: this.$t('material-group.title'), options: this.materialGroupOptions };
      filters.advanceBills = { type: 'checkbox', label: this.$t('report-summaries.bill.advanceBills'), options: this.advanceFilterOptions, class: 'col-md-2' }
      filters.clientName = { type: 'text', label: this.$t('client.name'), class: 'col-md-2' };
      return filters;
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale, 'disabled', 0);
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions(true);
    }
  },
  methods: {
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getReport();
    },
    downloadReports () {
      this.getReport(true);
    },
    downloadBill (billId) {
      this.ApiRequest.request('client-bill/' + billId, this.ApiRequest.REQUEST_DOWNLOAD, [], function () {
      });
    },
    reloadReport () {
      this.paging.page = 1;
      this.getReport();
    },
    getReport (download = false) {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      const self = this;
      const filterValues = this.BasicHelper.cloneObject(this.filterValues);
      let path = 'client-bill/billing-report';
      let reqType = this.ApiRequest.REQUEST_POST;
      if (download) {
        path += '?download=1';
        reqType = this.ApiRequest.REQUEST_DOWNLOAD;
        self.downloading = true;
      } else {
        if (!filterValues.simple) {
          path += '?perPage=' + this.paging.limit + '&page=' + this.paging.page;
        }
        self.loading = true;
      }
      this.currentReq = this.ApiRequest.request(path, reqType, filterValues, function (response) {
        if (download) {
          self.downloading = false;
        } else {
          if (response.data) {
            self.simpleView = filterValues.simple;
            self.reportData = response.data.items;
            self.paging = response.paging;
            if (self.simpleView) {
              self.tableHeaders = [
                { key: 'clientName', label: self.$t('client.name'), class: 'sticky-col', type: 'actionlinks', emit: 'viewclient', summaryCol: true, localFilter: true, sortable: true },
                { key: 'axaptCode', label: self.$t('client.axaptCode'), class: 'sticky-col', summaryCol: true, localFilter: true, sortable: true }
              ];
              self.reportColumns = response.data.columns;
              Object.keys(response.data.columns).forEach(elKey => {
                if (response.data.columns[elKey].basekey) {
                  self.tableHeaders.push({
                    key: elKey,
                    type: 'actionlinks',
                    emit: 'viewreport',
                    label: (response.data.columns[elKey].trans ? self.$t('report-summaries.bill.' + elKey) : response.data.columns[elKey].title),
                    actionFormat: 'formatDecimal',
                    precision: 2,
                    class: (response.data.columns[elKey].groupStart ? 'left-border' : ''),
                    basekey: response.data.columns[elKey].basekey
                  });
                } else {
                  self.tableHeaders.push({
                    key: elKey,
                    label: (response.data.columns[elKey].trans ? self.$t('report-summaries.bill.' + elKey) : response.data.columns[elKey].title),
                    format: 'formatDecimal',
                    precision: 2,
                    class: (response.data.columns[elKey].groupStart ? 'left-border' : '')
                  });
                }
              })
              const extraHeaders = [];
              Object.values(response.data.extraCols).forEach(val => {
                extraHeaders.push({
                  label: (val.material_group_id ? self.$options.filters.formatFromConfig(val.material_group_id, self.config.material_groups, 'name', self.$i18n.locale) : ''),
                  colspan: val.colspan,
                  class: 'left-border'
                })
              })
              self.tableHeaders[0].extraHeaders = [extraHeaders];
            }
          } else {
            self.reportData = null;
          }
          self.loading = false;
        }
      });
    },
    viewreport (idx, newtab, key) {
      const el = this.reportData[idx];
      if (el && this.reportColumns[key] && el[this.reportColumns[key].basekey + 'REP_CONFIG']) {
        const datePeriodId = key.split('_')[1];
        this.viewreportinfo(el.api_id, el[this.reportColumns[key].basekey + 'REP_CONFIG'], datePeriodId, newtab);
      }
    },
    viewreportinfo (clientId, reportConfigId, datePeriodId, newtab = false) {
      const reportCode = this.$store.getters.getParamFromConfig('report_configs', reportConfigId, 'code');
      if (newtab) {
        const routeData = this.$router.resolve({ name: 'menu.client.report', params: { clientApiId: clientId, reportCode: reportCode, datePeriodCode: datePeriodId } });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push('/client/' + clientId + '/report/' + reportCode + '/' + datePeriodId);
      }
    },
    viewclient (idx, newtab = false) {
      const el = this.reportData[idx];
      if (el) {
        if (newtab) {
          const routeData = this.$router.resolve({ name: 'menu.client.edit', params: { clientApiId: el.api_id } });
          window.open(routeData.href, '_blank');
        } else {
          this.$router.push('/client/' + el.api_id + '/edit');
        }
      }
    },
    getTableRowClass (item) {
      if (item.totalRow) {
        return 'summary-row colored';
      }
      return '';
    },
    rowSummaryLabel (field, item, value) {
      if (item.totalRow) {
        if (field.key === 'clientName') {
          return this.$t('general.total');
        } else if (field.format !== 'formatDecimal') {
          return this.$options.filters.formatDecimal(value, field.precision, this.$i18n.locale);
        }
      }
      return null;
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    if (this.filterValues.materialGroups.length === 0) {
      const self = this;
      this.materialGroupOptions.forEach(el => {
        self.filterValues.materialGroups.push(el.code);
      });
    }
    this.isMounted = true;
  }
}
